import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  DrawDetailResponse,
  DrawRewardResponse,
} from "@/api/backofficeRest/generated/model"
import { safeDayjs } from "@/helpers/dateHelper"
import { DrawDetail } from "./drawDetail"
import { IDrawDetail } from "./drawDetail.types"
import { DrawRewardParser } from "./drawReward.parser"

export const DrawDetailParser: IParser<IDrawDetail, DrawDetailResponse> = {
  toDomain: (data: DrawDetailResponse): IDrawDetail => {
    try {
      const startDateTime = safeDayjs(data.startDateTime)
      const entryDeadlineDateTime = safeDayjs(data.entryDeadlineDateTime)
      const completionDateTime = safeDayjs(data.completionDateTime)
      const winnerPublicationDateTime = safeDayjs(
        data.winnerPublicationDateTime,
      )
      const winnerNotificationDateTime = safeDayjs(
        data.winnerNotificationDateTime,
      )

      if (
        !startDateTime ||
        !entryDeadlineDateTime ||
        !completionDateTime ||
        !winnerPublicationDateTime ||
        !winnerNotificationDateTime
      ) {
        throw new Error("Missing required date field on DrawDetailResponse")
      }

      const rewards = (data.rewards ?? [])
        .filter(Boolean)
        .map((r) => DrawRewardParser.toDomain(r as DrawRewardResponse))

      return new DrawDetail(
        String(data.id),
        data.name,
        startDateTime,
        entryDeadlineDateTime,
        completionDateTime,
        winnerPublicationDateTime,
        Number(data.participantCount),
        rewards,
        winnerNotificationDateTime,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
